/**
 * GET /api/user/avatar-asset-group — 用户虚拟人像素材组（默认组 / 配置组）
 */

import { get, post } from '../request';
import { getApiBusinessFailureMessage } from '../utils/seedanceRequestUtils';
import { pickStringKeyIgnoreCase } from '../utils/seedancePortraitUtils';
import {
  buildVirtualPortraitAuthHeaders,
  type VirtualPortraitRequestOptions,
} from './virtualPortrait';

const BASE_URL = process.env.REACT_APP_AGI_BACK_URL || '/proxy/agiBack';

const userAvatarAssetGroupRequestConfig = (options: VirtualPortraitRequestOptions) => {
  const baseURL = options.baseURL ?? BASE_URL;
  const headers = buildVirtualPortraitAuthHeaders(options);
  options.onDebug?.('Headers: Authorization, New-Api-User');
  return {
    baseURL,
    headers,
    responseType: 'json' as const,
  };
};

export interface UserAvatarAssetGroupInfo {
  groupId: string;
}

export const parseUserAvatarAssetGroup = (res: unknown): UserAvatarAssetGroupInfo => {
  const root = res && typeof res === 'object' ? (res as Record<string, unknown>) : {};
  const data =
    root.data && typeof root.data === 'object' ? (root.data as Record<string, unknown>) : root;
  return {
    groupId: pickStringKeyIgnoreCase(data, 'groupid'),
  };
};

/** GET /api/user/avatar-asset-group */
export const getUserAvatarAssetGroup = async (
  options: VirtualPortraitRequestOptions,
): Promise<UserAvatarAssetGroupInfo> => {
  options.onDebug?.('POST /seedance/assets/default-group');
  const res = await post<unknown>('/seedance/assets/default-group', undefined, {
    ...userAvatarAssetGroupRequestConfig(options),
    cache: 'no-store',
  });
  const bizErr = getApiBusinessFailureMessage(res);
  if (bizErr) throw new Error(bizErr);
  return parseUserAvatarAssetGroup(res);
};
